import {onBeforeUnmount, onMounted, Ref} from 'vue';

export default function useDetectOutsideClick(component: Ref, callback: () => void) {
    if (!component) {
        return;
    }

    const listener = (event: Event) => {
        if (!component.value || component.value.contains(event.target)) {
            return;
        }

        callback();
    };
    onMounted(() => {
        window.addEventListener('click', listener);
    });
    onBeforeUnmount(() => {
        window.removeEventListener('click', listener);
    });

    return {listener};
}
